import React, { useState } from 'react';
import { Phone, Lock, Store  } from 'lucide-react';
import { toast } from 'react-toastify';
import { navigateTo } from "../../utils/navigation";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/';

const Login = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

 const handleLogin = async (e) => {
  e.preventDefault();

  if (!mobileNumber || !password) {
    toast.error('Please enter both mobile number and password!');
    return;
  }

  try {
    setLoading(true);

    const response = await fetch(`${BASE_URL}api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mobileNumber, password }),
    });

    // ✅ Read response safely once
    const data = await response.json();
    console.log("Response status:", response.status);
    console.log("Raw response:", data);

    if (response.status === 404) {
      toast.error('User not registered. Please sign up first.');
      navigateTo('/register');
    } 
    else if (response.status === 403) {
      toast.error(data.message || 'Mobile not verified. Please verify first.');
      navigateTo('/verify-otp');
    } 
    else if (response.ok) {  // ✅ simpler condition for 200–299
      toast.success('Login successful!');
      localStorage.setItem('accessToken', data.data.accessToken);
      localStorage.setItem('refreshToken', data.data.refreshToken);
      localStorage.setItem('user', JSON.stringify(data.data.user));
      navigateTo('/');
    } 
    else {
      toast.error(data.message || 'Invalid credentials!');
    }

  } catch (error) {
    console.error('Login error:', error);
    toast.error('Something went wrong! Please try again later.');
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="register-container">
      <div className="register-card">
        {/* Back Button */}
        <button className="back-button" type="button" onClick={() => navigateTo(-1)}>
          ←
        </button>

        {/* Header */}
        <div className="step-header">
          <h1 className="step-title">Welcome Back! 👋</h1>
          <p className="step-subtitle">Sign in to your account</p>
        </div>

        {/* Form */}
        <form className="form-content" onSubmit={handleLogin}>
          {/* Mobile Number */}
          <div className="form-group">
            <div className="input-container">
              <span className="input-icon">
                <Phone size={20} />
              </span>
              <input
                type="tel"
                className="form-input"
                placeholder="Mobile Number"
                autoComplete="tel"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div className="form-group">
            <div className="input-container">
              <span className="input-icon">
                <Lock size={20} />
              </span>
              <input
                type="password"
                className="form-input"
                placeholder="Password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {/* Forgot Password */}
          <div style={{ textAlign: 'right', marginBottom: '20px' }}>
            <span
              onClick={() => navigateTo('/forget-password')}
              style={{ fontSize: '14px', color: '#6366f1', cursor: 'pointer', fontWeight: '500' }}>
              Forgot Password?
            </span>
          </div>

          {/* Submit */}
          <button type="submit" className="primary-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        {/* Register Link */}
        <div className="login-section">
          Don't have an account?{' '}
          <span
            className="login-link"
            onClick={() => navigateTo('/register')}
            style={{ cursor: 'pointer' }}
          >
            Register
          </span>
        </div>

        {/* merchant Register Link */}
        <div className="login-section">
          Create the account as Merchant ?{' '}
          <span
            className="login-link"
            onClick={() => navigateTo('/merchant-register')}
            style={{ cursor: 'pointer' }}
          >
            Register Merchant <Store size={18} className="text-primary mb-1" stroke="#6366f1" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;
